export default "/images/9cd26a7b5dabc62bf29b039f3a50b3d7.png";